module.exports = __webpack_public_path__ + "0b8b9af0cfd0e9310ebf3af2a86aa9e3.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/assets/jacktop_pocker.png
// module id = 1684
// module chunks = 2